(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name EncuestaController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('EncuestaController', EncuestaController);

    EncuestaController.$inject = ["ProductService","$timeout","$location",'$anchorScroll'];

    function EncuestaController(ProductService,$timeout,$location,$anchorScroll)
    {

    	var vm = this;
        vm.carritoAdquirido = [];
        vm.carritoInteres = [];
        vm.loading = false;
        vm.numero_equipos = "";
        vm.form = { productos_adquiridos : '' };

        vm.comprobarEncuesta = function(){
            //console.log(vm.form);
            var comprobarCampos = comprobarBloqueFormulario('encuesta');
            if(comprobarCampos){
                if(vm.enc_electro==1){
                    if(!vm.form.productos_adquiridos){
                        $("html, body").animate({ scrollTop: $('.enc-prods').offset().top }, 400);
                        return false;
                    }
                }
            }
            if(comprobarCampos){
                sendFormularioCustomEncuesta('encuesta');
            }else{
                return comprobarCampos; 
            }

            //return true;
        }

        vm.numEq = function(){
            //console.log(vm);
            if(vm.num_equipos<=0){
                vm.num_equipos = 1;
            }
        }
        vm.eliminarCarAd = function(index){
            //console.log("eliminando");
            //console.log(index);
            vm.carritoAdquirido.splice(index,1);
        }
        vm.existeProductoAd = function(prod_id){
        	var res = false;
        	for(var cont= 0;cont<vm.carritoAdquirido.length && !res;cont++){
        		if(vm.carritoAdquirido[cont].id==prod_id){
        			res = true;
				}
        	}
        	return res;
        }

        vm.getProductosAdquiridos = function(){
        	var productos = [];
        	if(vm.carritoAdquirido.length>0){
	            for(var cont=0;cont<vm.carritoAdquirido.length;cont++){
                    if(vm.carritoAdquirido[cont].nombre){
    	                productos.push(vm.carritoAdquirido[cont].nombre);
                    }
	            }
	        }
            if(productos){
                vm.form.productos_adquiridos = productos.join(", ");
                return productos.join(", ");
            }else{
                vm.form.productos_adquiridos = "";
                return "";
            }
        }

        vm.getProductosInteres = function(){
        	var productos = [];
        	if(vm.carritoInteres.length>0){
	            for(var cont=0;cont<vm.carritoInteres.length;cont++){
	                productos.push(vm.carritoInteres[cont].nombre);
	            }
	        }
            return productos.join(", ");
        }

        vm.eliminarCarIn = function(index){
            vm.carritoInteres.splice(index,1);
        }

        vm.existeProductoIn = function(prod_id){
        	var res = false;
        	for(var cont= 0;cont<vm.carritoInteres.length && !res;cont++){
        		if(vm.carritoInteres[cont].id==prod_id){
        			res = true;
				}
        	}
        	return res;
        }

        vm.addprodIn = function(producto_id){
        	vm.loading = true;
	        //console.log(producto_id);
        	if(vm.productointeres_id!='otro'){
	        	ProductService.presupuestoProd(producto_id,function(data){
	        		if(!vm.existeProductoIn(producto_id)){
		        		vm.carritoInteres.push(data.producto);
		        	}
	        		vm.loading = false;
	            });
	        }else{
	        	if(!vm.existeProductoIn(producto_id)){
		    		vm.carritoInteres.push({id:producto_id,nombre:producto_id,foto:'',tipo_producto:''});
	        	}
	        }
        	//console.log(vm.carritoAdquirido);
        } 

 		vm.addprodAd = function(producto_id){
        	vm.loading = true;
	        //console.log(producto_id);
        	if(vm.productoadquirido_id!='otro'){
	        	ProductService.presupuestoProd(producto_id,function(data){
	        		if(!vm.existeProductoAd(producto_id)){
		        		vm.carritoAdquirido.push(data.producto);
		        	}
	        		vm.loading = false;
	            });
	        }else{
	        	if(!vm.existeProductoAd(producto_id)){
		    		vm.carritoAdquirido.push({id:producto_id,nombre:producto_id,foto:'',tipo_producto:''});
	        	}
	        }
        	//console.log(vm.carritoAdquirido);
        } 

       
    }


})();